/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import styles from './index.module.less';
import webview from '../../utils/webview';

export default class PaySuccess extends Component {
    state = {
        showDialogModal: false,
        dialogTitle: '',
        dialogContent: '',
        dialogOnCancel: null,
        dialogOnConfirm: null,
    }

    componentDidMount() {
        this.showDialog('','Thanh toán lần này đã thành công',null,()=>{
            this.props.history.replace('/recharge?processtype=1'); //跳转至充值首页
        });
    }
    /* 
    * 显示对话框
    * 当cancelCallback和confirmCallback都为空时，对话框将无法退出
     */
    showDialog = (title, content, cancelCallback, confirmCallback) => {
        const hideDialog = () => {
            this.setState({
                dialogTitle: '',
                dialogContent: '',
                showDialogModal: false,
                dialogOnCancel: null,
                dialogOnConfirm: null
            });
        }
        this.setState({
            dialogTitle: title,
            dialogContent: content,
            showDialogModal: true,
        });
        if (Object.prototype.toString.call(cancelCallback) === '[object Function]') {
            this.setState({
                dialogOnCancel: () => {
                    cancelCallback.call(this);
                    hideDialog();
                }
            });
        }

        if (Object.prototype.toString.call(confirmCallback) === '[object Function]') {
            this.setState({
                dialogOnConfirm: () => {
                    confirmCallback.call(this);
                    hideDialog();
                }
            });
        }
    }

    render() {
        const { showDialogModal, dialogTitle, dialogContent, dialogOnCancel, dialogOnConfirm } = this.state;

        return <>
            {showDialogModal ? <div className={styles.dialogModal}>
                <div className={styles.dialogWrapper}>
                    <div className={styles.dialogTitle}>{dialogTitle}</div>
                    {dialogContent ? <div className={styles.dialogContent}>{dialogContent}</div> : null}
                    <div className={styles.dialogButtons}>
                        {dialogOnCancel ? <button className={styles.dialogCancelBtn} onClick={dialogOnCancel}>Hủy</button> : null}
                        {dialogOnConfirm ? <button className={styles.dialogConfirmBtn} onClick={dialogOnConfirm}>Xác nhận</button> : null}
                    </div>
                </div>
            </div> : null}
        </ >
    }
}